import { Autocomplete, TextField } from '@mui/material'
import React from 'react'

const Destination = () => {
    return (
        <>
            <Autocomplete
                size='small'
                options={top100Films}
                renderInput={(params) => <TextField {...params} label="Destination" />}
            />
        </>
    )
}

export default Destination


const top100Films = [
    { label: 'The Shawshank Redemption', year: 1994 },
    { label: 'The Godfather', year: 1972 },
]